<template>
  <footer class="footer px-4">
    <div class="container-fluid">
      <nav class="top-footer-nav row">
        <div class="col-lg-6 col-md-3 col-12">
          <label for="google_translate_element" class="xxxsmall-font label-grey">Translate this page</label>
          <div id="google_translate_element"></div>
        </div>
        <div class="col-lg-2 col-md-3 col-12 mt-3 m-md-0">
            <ul class="list-group">
              <li class="list-group-item list-group-item-header">Find</li>
              <li class="list-group-item">
                <a
                  href="https://web.mississauga.ca/publications/"
                  target="_blank"
                   rel="noreferrer"
                >
                  Publications
                </a>
              </li>
              <li class="list-group-item">
                <a
                  href="https://web.mississauga.ca/services-and-programs/pay-apply-report/"
                  target="_blank"
                   rel="noreferrer"
                >
                  Pay, apply, report
                </a>
              </li>
              <li class="list-group-item">
                <a
                  href="https://web.mississauga.ca/services-and-programs/services-a-to-z/"
                  target="_blank"
                   rel="noreferrer"
                >
                  Services A to Z
                </a>
              </li>
            </ul>
          </div>

        <div class="col-lg-2 col-md-3 col-12 mt-3 m-md-0">
            <ul class="list-group">
              <li class="list-group-item list-group-item-header">
                Get in touch
              </li>
              <li class="list-group-item">
                <a
                  href="https://web.mississauga.ca/home/contact-us/"
                  target="_blank"
                   rel="noreferrer"
                  >Contact Us</a
                >
              </li>
              <li class="list-group-item">
                <a
                  href="https://web.mississauga.ca/home/get-email-updates/"
                  target="_blank"
                   rel="noreferrer"
                >
                  Get email updates
                </a>
              </li>
            </ul>
          </div>
        <div class="col-lg-2 col-md-3 col-12 mt-3 m-md-0">
          <ul class="list-group">
            <li class="list-group-item list-group-item-header">Social</li>
            <li class="list-group-item">
               <font-awesome-icon :icon="['fab', 'twitter']" size="sm" />&nbsp;
              <a href="https://twitter.com/citymississauga" target="_blank" title="Follow us on Twitter"  rel="noreferrer">
                Twitter
              </a>
            </li>
            <li class="list-group-item">
              <font-awesome-icon :icon="['fab', 'facebook']" size="sm" />&nbsp;
              <a href="https://www.facebook.com/citymississauga" target="_blank" title="Follow us on Facebook" rel="noreferrer">
                 Facebook
              </a>
            </li>
            <li class="list-group-item">
              <font-awesome-icon :icon="['fab', 'linkedin']" size="sm" />   &nbsp;
              <a href="https://www.linkedin.com/company/city-of-mississauga/" target="_blank"  title="Follow us on Linkedin" rel="noreferrer">
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div class="footer-border"></div>
    <div class="container">
      <nav class="bottom-footer-nav text-center">
        <div class="row">
          <div class="col-md-2 col-12">
            <p class="inline xxxsmall-font">© City of Mississauga</p>
          </div>
          <div class="col-md-8 col-12 text-center">
            <ul class="list-inline">
              <li>
                <a href="https://web.mississauga.ca/home/privacy-and-terms/"  title="Terms">Privacy and terms</a>
              </li>
              <li>
                <a>|</a>
              </li>
              <li>
                <a href="https://web.mississauga.ca/home/accessibility/" title="Accessibility">Accessibility</a>
              </li>
            </ul>
          </div>
          <div class="col-2"></div>
        </div>
      </nav>
    </div>
    
  </footer>
</template>

<script>
import "@/assets/sass/footer.scss";

export default {
  name: "Footer",
  methods: { 
           scrollToTop() {
                window.scrollTo(0,0);
           }
        }
};
</script>
